import { useEffect, useState } from 'react';

// 轻量全局 toast：任意处 `toast('已复制')` 即可；ToastHost 在 App 挂一次。
export function toast(msg: string) {
  window.dispatchEvent(new CustomEvent('kpqd-toast', { detail: msg }));
}

interface Item { id: number; msg: string; leaving?: boolean }

export function ToastHost() {
  const [items, setItems] = useState<Item[]>([]);
  useEffect(() => {
    let n = 0;
    const on = (e: Event) => {
      const msg = (e as CustomEvent<string>).detail;
      const id = ++n;
      setItems((s) => [...s, { id, msg }]);
      // 2.2s 后标记离场，2.5s 后移除（配合 CSS 淡出）
      setTimeout(() => setItems((s) => s.map((x) => (x.id === id ? { ...x, leaving: true } : x))), 2200);
      setTimeout(() => setItems((s) => s.filter((x) => x.id !== id)), 2500);
    };
    window.addEventListener('kpqd-toast', on as EventListener);
    return () => window.removeEventListener('kpqd-toast', on as EventListener);
  }, []);

  return (
    <div className="toast-host">
      {items.map((i) => (
        <div key={i.id} className={`toast-item${i.leaving ? ' leaving' : ''}`}>{i.msg}</div>
      ))}
    </div>
  );
}
